import React, { useState } from "react";

function Chevron({ open }: { open: boolean }) {
  return (
    <svg
      className={`block size-4 shrink-0 text-[#605d66] transition-transform duration-150 ${
        open ? "rotate-90" : ""
      }`}
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M9 6L15 12L9 18"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}

/**
 * A titled panel that folds away. The credit calculator and the currency
 * converter are reference tools rather than part of the form, so they start
 * collapsed and stop the modal from outgrowing the viewport.
 */
export default function CollapsibleSection({
  title,
  subtitle,
  defaultOpen = false,
  headerRight,
  children,
}: {
  title: string;
  subtitle?: string;
  defaultOpen?: boolean;
  headerRight?: React.ReactNode;
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div
      className={`rounded-2xl border transition-colors ${
        open
          ? "border-[#eae7ec] bg-[rgba(253,252,253,0.72)]"
          : "border-[#eae7ec] bg-[rgba(250,249,251,0.6)]"
      }`}
    >
      <div className="flex flex-row items-center gap-3 px-4 py-3">
        <button
          type="button"
          onClick={() => setOpen((current) => !current)}
          aria-expanded={open}
          className="flex min-w-px grow cursor-pointer flex-row items-center gap-2.5 text-left"
        >
          <Chevron open={open} />
          <span className="font-['Geist:Medium',_sans-serif] text-[13px] font-medium leading-[18px] text-[#211f26]">
            {title}
          </span>
          {subtitle && (
            <span className="truncate font-['Geist:Regular',_sans-serif] text-[12px] leading-[16px] text-[#84828e]">
              {subtitle}
            </span>
          )}
        </button>
        {/* Rendered outside the toggle so its own controls stay clickable. */}
        {headerRight}
      </div>
      {open && (
        <div className="border-t border-[#eae7ec] px-4 py-4">{children}</div>
      )}
    </div>
  );
}
